var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8News1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33337H30V25.3334C30 26.806 28.806 28 27.3333 28H6V7.33337Z",
    fill: "#FB348C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 28H4.66667C3.194 28 2 26.806 2 25.3333V4H24.6667V25.3333C24.6667 26.806 25.8607 28 27.3333 28Z",
    fill: "#FFECAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 25.3334V7.33337H24.6667V25.3334C24.6667 26.806 25.8607 28 27.3333 28H4.66667C3.194 28 2 26.806 2 25.3334Z",
    fill: "#FFDD64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H4.66663V14.6667H22V10Z",
    fill: "#FC9F35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.3334H4.66663V20H12V17.3334Z",
    fill: "#FC9F35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6666H4.66663V25.3333H12V22.6666Z",
    fill: "#FC9F35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.3334H14.6666V20H22V17.3334Z",
    fill: "#FC9F35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.6666H14.6666V25.3333H22V22.6666Z",
    fill: "#FC9F35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8News1);
export default __webpack_public_path__ + "static/media/icons8-news-1.ced3b0278c2f2f7f9cf96227420e0b99.svg";
export { ForwardRef as ReactComponent };